module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"companyName":"Название компании","companySite":"Сайт компании","user":"Пользователь","firstName":"Имя","lastName":"Фамилия","email":"E-mail","pass":"Пароль","agreeTo":"Согласен с","privacyPolicy":"политикой конфиденциальности","register":"Зарегистрироваться","company":"Компания","companyCountry":"Страна","noCountryFound":"Страна не найдена","repeatPass":"Повторите пароль"}}')
  delete Component.options._Ctor
}
